import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { isCC, isNCAA, isNCAAAllSports, isOSULacrosse, isTA } from '../../helpers';
import { CUSTOMER_RESTRICTED_PAGES, MOBILE_RESTRICTED, NFL_EXCLUSIVE_PAGES, TA_RESTRICTED_PAGES, } from '../../config/constants';
import { useUserState } from '../../store/hooks';

const AuthorizedRoute = ({ component: Component, ...rest }: any) => {
  
  const user = useUserState();
  
  const isTAResticted = rest.path.split('/').reduce((total: boolean, currentValue: string) => {
    return total || TA_RESTRICTED_PAGES.includes(currentValue);
  }, false);
  const isCustomerRestricted = rest.path.split('/').reduce((total: boolean, currentValue: string) => {
    return total || CUSTOMER_RESTRICTED_PAGES.includes(currentValue);
  }, false);
  const isNFLExclusive = rest.path.split('/').reduce((total: boolean, currentValue: string) => {
    return total || NFL_EXCLUSIVE_PAGES.includes(currentValue);
  }, false);
  const isMobileRestricted = rest.path.split('/').reduce((total: boolean, currentValue: string) => {
    return total || MOBILE_RESTRICTED.includes(currentValue); 
  }, false);
  
  const userIsCC = isCC(user); // 261
  const userIsTA = isTA(user);
  const userIsNCAA = isNCAA(user);
  const userISNCAAAllSports = isNCAAAllSports(user);
  const userIsOSULacrosse = isOSULacrosse(user);
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  
  const userIsAnyNCAA = userIsNCAA || userISNCAAAllSports || userIsOSULacrosse;
  
  const currentUserCanAccessPath = (isMobile? userIsCC && isMobile && !isMobileRestricted : userIsCC ) ||  // CC can access any path
    (userIsTA && !isTAResticted) || // TA checks. path can't be resttricted to TA
    (userIsAnyNCAA && !isNFLExclusive && !isCustomerRestricted) || // NCAA general check, since the base access level for any NCAA user is curtomers pages
    (userISNCAAAllSports && !isNFLExclusive && !isTAResticted) || // special check for NCAAAllSports which, as I understand, has the same access level as a TA
    (!userIsCC && !userIsTA && !userISNCAAAllSports && !isCustomerRestricted); // Customer account checks.
  
  return (
    currentUserCanAccessPath ?
      <Route {...rest} render={props => <Component {...props} />} /> :
      <Redirect to="/404" />
  );
};

export default AuthorizedRoute;
